import React from 'react'
import Footer from 'components/Footer'

export default function index() {
    return (
        <>
            <iframe style={{ minWidth: '1300px' }} src="/static/components/a.html" frameBorder="0" width="100%" height="432px"></iframe>
            <Footer />
        </>
    )
}
